import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './images/image.png';
import _imports_1 from '../Footer/images/weixin_i.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-566bd046"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container-fluild long-container bottmo_footer"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "footer_line"
  }, null, -1);
});

var _hoisted_3 = {
  class: "container"
};
var _hoisted_4 = {
  class: "row long-row"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "col-md-7 contact"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "phone_number_title"
  }, "联系电话"), /*#__PURE__*/_createElementVNode("div", {
    class: "phone_number"
  }, "400-135-5066")], -1);
});

var _hoisted_6 = {
  class: "col-md-5 navigation"
};
var _hoisted_7 = {
  class: "footer_menu_box"
};
var _hoisted_8 = {
  class: "footer_img"
};
var _hoisted_9 = {
  class: "weixin_QR_code_box_footer"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "weixin_QR_code"
  }, null, -1);
});

var _hoisted_11 = [_hoisted_10];

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "record_num_box"
  }, [/*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn",
    class: "jumpLink"
  }, "沪ICP备2023006309号-1"), /*#__PURE__*/_createTextVNode(" 版权所有 元羿生物 COPYRIGHT 2024 SUMMIT,ALL RIGHTS RESERVED ")], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "footer_menus",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $setup.jumpTo('contactUs');
    })
  }, "联系我们"), _createElementVNode("div", {
    class: "footer_menus footer_none",
    onClick: _cache[1] || (_cache[1] = function () {
      return $setup.jumpLegalNotice && $setup.jumpLegalNotice.apply($setup, arguments);
    })
  }, "法律声明"), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("div", _hoisted_9, _hoisted_11, 512), [[_vShow, $setup.weixinFlag]]), _createElementVNode("img", {
    src: _imports_1,
    class: "weixin_i",
    onMouseenter: _cache[2] || (_cache[2] = function ($event) {
      return $setup.showWeixin();
    }),
    onMouseleave: _cache[3] || (_cache[3] = function () {
      return $setup.leaveWeixin && $setup.leaveWeixin.apply($setup, arguments);
    })
  }, null, 32)])])]), _hoisted_12])])]);
}